import { helper } from '@ember/component/helper';

const PLACEHOLDERS = {
  'teacher-comment':
    'This student has made steady progress this term, showing particular strength in reading comprehension and creative writing. They actively participate in class discussions and demonstrate a positive attitude towards learning.',
  'next-steps':
    'Continue to develop reading fluency by practising at home for 15 minutes each day. Focus on building confidence with multi-step maths problems.',
  'help-at-home':
    'Encourage your child to read aloud at home and discuss stories together. Practise times tables using everyday activities like cooking and shopping.',
};

export default helper(function narrativePlaceholder([type]) {
  return PLACEHOLDERS[type] || '';
});
